module.exports = __webpack_public_path__ + "c3e070be7f1a0c489f078004db56d78a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/filter_sample.png
// module id = 2
// module chunks = 0 1 2 3 4